/*
 * @Author: Branton
 * @Date: 2025-10-28 17:01:49
 * @LastEditTime: 2025-10-28 17:53:34
 * @LastEditors: Branton
 * @Description:
 * @FilePath: \Rms-Tender-Frontend\src\views\pages\AnnouncementDetails\hooks\Footer\Form\useUnrelatedForm.tsx
 * 暂无
 */
import ZeissSelect from '@components/select';
import { ROLE_KEYS_MAP } from '@constants';
import { DicListHook } from '@hooks/useDicListHook';
import { userInfo } from '@store';
import { DataFlagEnum } from '@views/pages/AnnouncementList/announcement';
import { Form, Input } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useRecoilState } from 'recoil';
import './index.scss';
const { TextArea } = Input;

// 不相关原因 其他选项的id值
const OTHER_ID = '99';

export const useUnrelatedForm = (
  unrelatedTip: boolean,
  details: any = {},
  isAnnouncement: boolean = false
) => {
  const [userInfos] = useRecoilState(userInfo);
  const dict = DicListHook();
  // 公告不相关原因/标的物一期不相关原因/标的物二期不相关原因
  const {
    noticeTwoUnCorrelatedReason,
    subjectOneUnCorrelatedReason,
    subjectTwoUnCorrelatedReason
  } = dict;
  const [unrelatedReasonOptions, setUnrelatedReasonOptions] = useState([]);
  const [isRecordRemarkRequired, setIsRecordRemarkRequired] = useState(false);

  const isSales = userInfos.roleKeys === ROLE_KEYS_MAP.sales;
  const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;

  // 计算不相关原因的下拉选项
  const calcOptions = () => {
    if (isAnnouncement) {
      return noticeTwoUnCorrelatedReason;
    }
    if (isSales && details.dataFlag === DataFlagEnum.directSelling) {
      return subjectOneUnCorrelatedReason;
    } else if (
      (isSales && details.dataFlag === DataFlagEnum.dealer) ||
      isDealer
    ) {
      return subjectTwoUnCorrelatedReason;
    }
  };

  useEffect(() => {
    setUnrelatedReasonOptions(calcOptions());
  }, [dict, isAnnouncement]);

  const onunRelatedReasonChange = (value: any) => {
    const id = value?.split('-')[0];
    setIsRecordRemarkRequired(id == OTHER_ID);
  };

  const unrelatedForm = useMemo(() => {
    return (
      <div className="pc-footer-repeat">
        {!unrelatedTip && (
          <div className="pc-footer-unrelatedTip">
            该公告的标的物不在当前市占率分析范围内
          </div>
        )}
        {(isSales || isDealer) && (
          <Form.Item
            label={'原因：'}
            name={'unrelatedReason'}
            rules={[{ required: true }]}
          >
            <ZeissSelect
              options={unrelatedReasonOptions}
              // fieldNames={DIC_FIELD_NAMES}
              onChange={onunRelatedReasonChange}
            ></ZeissSelect>
          </Form.Item>
        )}

        <Form.Item
          label={'备注：'}
          name={'recordRemark'}
          rules={[{ required: isRecordRemarkRequired }]}
        >
          <TextArea placeholder="输入备注内容" rows={3} />
        </Form.Item>
      </div>
    );
  }, [unrelatedReasonOptions, isRecordRemarkRequired]);

  return {
    unrelatedForm
  };
};
